<template>
    <div class="welcome-landing-root grade-10-curriculum-page min-h-screen bg-background">
        <welcome-navbar />
        <grade-10-curriculum-landing />
        <welcome-footer />
    </div>
</template>

<script>
import WelcomeNavbar from '@/components/welcome/landing/WelcomeNavbar.vue';
import WelcomeFooter from '@/components/welcome/landing/WelcomeFooter.vue';
import Grade10CurriculumLanding from '@/components/welcome/landing/grade10-curriculum/Grade10CurriculumLanding.vue';

export default {
    name: 'Grade10Curriculum',
    components: {
        WelcomeNavbar,
        WelcomeFooter,
        Grade10CurriculumLanding,
    },
};
</script>

<style src="@/scss/welcome-landing.css"></style>
<style src="@/scss/grade-10-curriculum.css"></style>
<style src="@/seo/seo.css"></style>
